

































































































































































































































































































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";

import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  minLength,
  minValue,
  numeric,
} from "vuelidate/lib/validators";

import { VueEditor } from "vue2-editor";

import SubmitResetButtonGroop from "@/components/app/shared/btn&dd/submit-reset-button-groop.vue";
import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type { Route } from "@/@types/route-info/v2/v2.routes";
import type { CityFeature } from "@/@types/route-info/v2/v2.citys";
import type { LanguageCode, Locale } from "@/@types/_shared/locale";
import type { SICON } from "@/@types/_shared/src";

interface CityOrderEntry {
  cityId: string;
  arrival: string;
  departure: string;
  stayDuration: number;
  notes: Locale;
  activities: string[];
}

interface PricingCategoryEdit {
  _id: string;
  name: Locale;
  price: number;
  description: Locale;
  name_display: string;
  description_display: string;
}

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    LanguagesBtns,
    VueEditor,
    UploadPicture,
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(100),
    },

    description: {
      maxLength: maxLength(5000),
    },

    selectedCities: {
      required,
      minLength: minLength(2),
    },
  },
})
class RouteInfoV2AddRoute extends Vue {
  @Prop({ type: Object, default: null }) item!: Route | null;
  @Prop({ type: Array, default: () => [] }) citis!: CityFeature[];

  @Inject("routeFolder") routeFolder!: string;

  currentLocale: LanguageCode =
    (this.$store.getters.getLanguages && this.$store.getters.getLanguages[0]) ||
    "ru";

  name = "";
  description = "";
  names: Locale = {};
  descriptions: Locale = {};

  type: "railway" | "river" | "combined" = "combined";
  status: "draft" | "active" | "inactive" | "archived" = "draft";
  difficulty: "easy" | "moderate" | "difficult" = "easy";
  tags: string[] = [];

  selectedCities: CityOrderEntry[] = [];
  cityToAdd = "";

  pricing_currency = "RUB";
  pricing_categories: PricingCategoryEdit[] = [];

  src_image = "";
  src_poster = "";
  src_background = "";
  src_vertical_poster = "";
  src_horizontal_poster = "";
  src_icon: SICON = { icon: "", lib: "" };

  get computedDurationText(): string {
    const cities = this.selectedCities;
    if (cities.length < 2) return "";

    const startDate = cities[0].departure
      ? new Date(cities[0].departure)
      : null;
    const lastCity = cities[cities.length - 1];
    const endDate = lastCity.arrival
      ? new Date(lastCity.arrival)
      : lastCity.departure
      ? new Date(lastCity.departure)
      : null;

    if (!startDate || !endDate) return "";

    const diffMs = endDate.getTime() - startDate.getTime();
    if (diffMs <= 0) return "";

    const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
    const totalDays = Math.floor(totalHours / 24);
    const remainingHours = totalHours % 24;
    const nights = Math.max(0, totalDays);

    const parts: string[] = [];
    if (totalDays > 0)
      parts.push(
        `${totalDays} ${this.$tc("route_info.route.days", totalDays)}`
      );
    if (remainingHours > 0)
      parts.push(
        `${remainingHours} ${this.$t(
          "route_editor.fields.duration.hours.label"
        )}`
      );
    return parts.join(", ") || `${totalHours}h`;
  }

  get computedDuration() {
    const cities = this.selectedCities;
    if (cities.length < 2)
      return { totalDays: undefined, totalHours: undefined, nights: undefined };

    const startDate = cities[0].departure
      ? new Date(cities[0].departure)
      : null;
    const lastCity = cities[cities.length - 1];
    const endDate = lastCity.arrival
      ? new Date(lastCity.arrival)
      : lastCity.departure
      ? new Date(lastCity.departure)
      : null;

    if (!startDate || !endDate)
      return { totalDays: undefined, totalHours: undefined, nights: undefined };

    const diffMs = endDate.getTime() - startDate.getTime();
    if (diffMs <= 0)
      return { totalDays: undefined, totalHours: undefined, nights: undefined };

    const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
    const totalDays = Math.floor(totalHours / 24);
    const nights = Math.max(0, totalDays);

    return {
      totalDays: totalDays || undefined,
      totalHours: totalHours || undefined,
      nights: nights || undefined,
    };
  }

  get availableCitiesToAdd() {
    return this.citis.map((c) => ({
      value: c._id || "",
      text: this.$getLocale(c.properties.name),
    }));
  }

  removeCityFromRoute(index: number): void {
    this.selectedCities.splice(index, 1);
    this.recalcAllStays();
  }

  addCityToRoute(): void {
    if (!this.cityToAdd) return;
    this.selectedCities.push({
      cityId: this.cityToAdd,
      arrival: "",
      departure: "",
      stayDuration: 0,
      notes: {},
      activities: [],
    });
    this.cityToAdd = "";
    this.recalcAllStays();
  }

  calcStay(entry: CityOrderEntry): void {
    if (entry.arrival && entry.departure) {
      const a = new Date(entry.arrival).getTime();
      const d = new Date(entry.departure).getTime();
      if (d > a) {
        entry.stayDuration = Math.round(((d - a) / (1000 * 60 * 60)) * 10) / 10;
      } else {
        entry.stayDuration = 0;
      }
    } else {
      entry.stayDuration = 0;
    }
  }

  recalcAllStays(): void {
    this.selectedCities.forEach((e) => this.calcStay(e));
  }

  get routeTypes() {
    return [
      { value: "railway", text: this.$t("route_editor.fields.type.railway") },
      { value: "river", text: this.$t("route_editor.fields.type.river") },
      { value: "combined", text: this.$t("route_editor.fields.type.combined") },
    ];
  }

  get statuses() {
    return [
      { value: "draft", text: this.$t("route_editor.fields.status.draft") },
      { value: "active", text: this.$t("route_editor.fields.status.active") },
      {
        value: "inactive",
        text: this.$t("route_editor.fields.status.inactive"),
      },
      {
        value: "archived",
        text: this.$t("route_editor.fields.status.archived"),
      },
    ];
  }

  get difficultyOptions() {
    return [
      { value: "easy", text: this.$t("route_editor.fields.difficulty.easy") },
      {
        value: "moderate",
        text: this.$t("route_editor.fields.difficulty.moderate"),
      },
      {
        value: "difficult",
        text: this.$t("route_editor.fields.difficulty.difficult"),
      },
    ];
  }

  get mapSities() {
    return this.selectedCities.map((entry, index) => {
      const isStartPoint = index === 0;
      const isEndPoint = index === this.selectedCities.length - 1;

      return {
        city: entry.cityId,
        order: index,
        isStartPoint,
        isEndPoint,
        arrival: entry.arrival ? new Date(entry.arrival) : null,
        departure: entry.departure ? new Date(entry.departure) : null,
        stayDuration: entry.stayDuration || 0,
        activities: entry.activities,
        notes: entry.notes,
        transport: null,
      };
    });
  }

  get route(): Route {
    return {
      _id: (this.item && this.item._id) || "",
      name: this.names,
      description: this.descriptions,
      type: this.type,
      status: this.status,
      season: this.item ? this.item.season : undefined,

      duration: this.computedDuration,

      cities: this.mapSities as any,
      transports: [] as any,

      pricing: {
        currency: this.pricing_currency,
        categories: this.pricing_categories.map((c) => ({
          _id: c._id,
          name: c.name,
          price: c.price,
          description: c.description,
        })),
      },
      src: {
        image: this.src_image,
        poster: this.src_poster,
        vertical_poster: this.src_vertical_poster,
        horizontal_poster: this.src_horizontal_poster,
        icon: this.src_icon,
        background: this.src_background,
      },
      difficulty: this.difficulty,
      tags: this.tags,
    };
  }

  onSubmit(e: Event) {
    e.preventDefault();
    this.$v.$touch();
    if (this.$v.$invalid) return;

    this.$emit("setRouteV2", this.route);
  }

  @Watch("name")
  addName() {
    this.$set(this.names, this.currentLocale, this.name);
  }
  @Watch("description")
  addDescription() {
    this.$set(this.descriptions, this.currentLocale, this.description);
  }

  @Watch("currentLocale")
  changeLocale() {
    this.name = this.names[this.currentLocale] || "";
    this.description = this.descriptions[this.currentLocale] || "";
    this.syncPricingDisplay();
  }

  private syncPricingDisplay() {
    this.pricing_categories.forEach((c) => {
      c.name_display = c.name[this.currentLocale] || "";
      c.description_display = c.description[this.currentLocale] || "";
    });
  }

  @Watch("item", { immediate: true })
  createFields() {
    if (!this.item) {
      this.isClean();
      return;
    }

    this.names = { ...(this.item.name || {}) };
    this.descriptions = { ...(this.item.description || {}) };
    this.type = this.item.type;
    this.status = this.item.status;

    if (this.item.cities && this.item.cities.length) {
      this.selectedCities = this.item.cities.map((x: any) => ({
        cityId:
          x.city && x.city._id
            ? x.city._id
            : typeof x.city === "string"
            ? x.city
            : "",
        arrival: x.arrival
          ? new Date(x.arrival).toISOString().slice(0, 16)
          : "",
        departure: x.departure
          ? new Date(x.departure).toISOString().slice(0, 16)
          : "",
        stayDuration: x.stayDuration || 0,
        notes: { ...(x.notes || {}) },
        activities: [...(x.activities || [])],
      }));
    } else {
      this.selectedCities = [];
    }

    this.difficulty = this.item.difficulty || "easy";
    this.tags = [...(this.item.tags || [])];
    this.src_image = (this.item.src && this.item.src.image) || "";
    this.src_poster = (this.item.src && this.item.src.poster) || "";
    this.src_background = (this.item.src && this.item.src.background) || "";
    this.src_vertical_poster =
      (this.item.src && this.item.src.vertical_poster) || "";
    this.src_horizontal_poster =
      (this.item.src && this.item.src.horizontal_poster) || "";
    this.src_icon = {
      ...((this.item.src && this.item.src.icon) || { icon: "", lib: "" }),
    };

    if (this.item.pricing) {
      this.pricing_currency = this.item.pricing.currency || "RUB";
      this.pricing_categories = (this.item.pricing.categories || []).map(
        (c: any) => {
          const nameLocale: Locale =
            typeof c.name === "object" && c.name !== null ? { ...c.name } : {};
          const descLocale: Locale =
            typeof c.description === "object" && c.description !== null
              ? { ...c.description }
              : {};
          return {
            _id: c._id || Date.now().toString(),
            name: nameLocale,
            price: c.price || 0,
            description: descLocale,
            name_display: nameLocale[this.currentLocale] || "",
            description_display: descLocale[this.currentLocale] || "",
          };
        }
      );
    }

    this.changeLocale();
    this.recalcAllStays();
  }

  isClean() {
    this.name = "";
    this.description = "";
    this.names = {};
    this.descriptions = {};
    this.selectedCities = [];
    this.cityToAdd = "";
    this.type = "combined";
    this.status = "draft";
    this.tags = [];
    this.src_background = "";
    this.src_horizontal_poster = "";
    this.src_icon = { lib: "", icon: "" };
    this.src_image = "";
    this.src_poster = "";
    this.src_vertical_poster = "";
    this.pricing_categories = [];
    this.$v.$reset();
  }

  mounted(): void {
    this.createFields();
    this.$root.$on("bv::modal::shown", (_: any, modalId: string) => {
      if (modalId === "route-info-v2-add-route") {
        this.createFields();
      }
    });
  }

  beforeDestroy(): void {
    this.$root.$off("bv::modal::shown");
  }

  getCityName(id: string) {
    const city = this.citis.find((x) => x._id === id);
    return city ? this.$getLocale(city.properties.name) : id;
  }

  addPrice() {
    this.pricing_categories.push({
      _id: Date.now().toString(),
      name: {},
      price: 0,
      description: {},
      name_display: "",
      description_display: "",
    });
  }

  removePrice(index: number) {
    this.pricing_categories.splice(index, 1);
  }
}

export default RouteInfoV2AddRoute;
